<template lang="pug">
  .dropdown-container
    slot
    .options-container(v-if='showOptions' v-on-clickaway='hideMenu' :style='position')
      component.black.row.middle(
        :class='option.shouldDisable && trialRemainingDays ? "gray" : "black"'
        :is='setTag(option.tag)'
        v-for='(option, index) in options'
        type='button'
        :key='index'
        v-on='{ [option.event || "click"]: eventHandler(option) }'
        v-html='option.label'
        v-bind='option.elementsToBeBinded'
        :disabled='option.shouldDisable && trialRemainingDays'
      )
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import userRole from '../mixins/userRole'

export default {
  mixins: [ clickaway, userRole ],
  props: {
    options: { type: Array, required: true },
    showOptions: { type: Boolean, required: true },
    centered: { type: Boolean, required: false, default: false },
    rightPosition: { type: String, required: false },
    topPosition: { type: String, required: false }
  },
  computed: {
    position() {
      return {
        '--right-position': this.rightPosition,
        '--top-position': this.topPosition
      }
    },
    trialRemainingDays() {
      return this.isTrial && this.remainingDays === 0
    }
  },
  methods: {
    hideMenu() {
      this.$emit('hideMenu')
    },
    setTag(customTag) {
      return customTag || 'button'
    },
    eventHandler(option) {
      return option.handleClick || (() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';

.dropdown-container {
  position: relative;
  --container-size: 180px;
  --top-position: calc(100% + 10px);
}

.options-container {
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 3px;
  box-shadow: 0 3px 10px 0 $shadow-blacker;
  display: flex;
  flex-direction: column;
  position: absolute;
  right: var(--right-position);
  top: var(--top-position);
  width: var(--container-size);
  z-index: 15;

  &.centered {
    right: 10%;
  }

  &::before {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid $white;
    content: '';
    height: 0;
    position: absolute;
    right: 15px;
    top: -5px;
    width: 0;
    z-index: 15
  }

  &::after {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid $light-gray;
    content: '';
    height: 0;
    position: absolute;
    right: 13px;
    top: -7px;
    width: 0;
    z-index: 14;
  }

  & > :not(:last-child) {
    border-bottom: 1px solid $light-gray;
  }

  & > :nth-child(n) {
    height: 40px;
    padding: 12px;
    text-align: left;
    width: 100%;

    &:hover {
      background-color: $light-gray;
    }
  }
}
</style>
